import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  chgActeurFilter,
  chgEvenementFilter,
  selectInSocialFilters,
} from "../../../redux/ReduxFilter";

const BlocFiltreInSocial = (props) => {
  const { t } = useTranslation();
  const _selectInSocialFilters = useSelector(selectInSocialFilters);
  const dispatch = useDispatch();

  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container fluid className="mb-3 d-flex align-items-center flex-nowrap containerFiltres">
        <div className="m-1  align-items-center d-flex">
          <Form.Check
            className={_selectInSocialFilters.evenement ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre4")}
            id="evenement"
            name="evenement"
            onChange={(e) => dispatch(chgEvenementFilter(!_selectInSocialFilters.evenement))}
            checked={_selectInSocialFilters.evenement ? "checked" : ""}
          />
        </div>
        <div className="m-1 s align-items-center d-flex">
          <Form.Check
            className={_selectInSocialFilters.acteur ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre7")}
            id="acteur"
            name="acteur"
            onChange={(e) => dispatch(chgActeurFilter(!_selectInSocialFilters.acteur))}
            checked={_selectInSocialFilters.acteur ? "checked" : ""}
          />
        </div>
      </Container>
    </div>
  );
};

export default BlocFiltreInSocial;
